import { Smartphone } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function AppBadge({ show, testId = "app-badge" }) {
  if (!show) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="climber-badge inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-extrabold text-white bg-gradient-to-r from-rose-500 to-fuchsia-500 shadow-md shadow-rose-300/60 ring-1 ring-rose-300 active:scale-95 transition-transform">
          <Smartphone className="w-3.5 h-3.5" /> App-Nutzer
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 rounded-2xl text-sm text-slate-600" data-testid={`${testId}-info`}>
        <p className="font-bold text-slate-900">📱 App-Nutzer</p>
        <p className="mt-1">Hat die itzPlay App auf dem Handy installiert. Hol sie dir auch – in 3 Schritten über das Menü „App installieren“.</p>
      </PopoverContent>
    </Popover>
  );
}
